import { OrgRoleTitles } from '@copilot/common/config/roles';
import { IOrganizationTeamMember } from './models';

export const getMemberRoleType = (member: IOrganizationTeamMember): OrgRoleTitles =>
	member.isOrgAdmin
		? OrgRoleTitles.Admin
		: member.isOrgAdvanced
		? OrgRoleTitles.Advanced
		: OrgRoleTitles.User;
